import script from "./BuyTokensNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyTokensNotice.vue?vue&type=script&setup=true&lang=ts"

import "./BuyTokensNotice.vue?vue&type=style&index=0&id=01e925ab&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01e925ab"]])

export default __exports__